export default __webpack_public_path__ + "static/media/plain-sticker-Z.2a1c8d27.png";